<template>
  <w-scale :scale-show="state" @handleClose="handleClose">
    <div class="scale-dialog flex-column-center" slot="content" @touchmove.prevent>
      <img @click="handleClose" class="close-icon" src="https://files.wondercv.com/close.png" alt="">
      <img class="scale-temp-img" :src="scaleTemp[`${scaleTemp.currentLang}_img`]" alt="">
      <div @click.stop="cvByTemp(scaleTemp)" class="use flex-center">使用模板</div>
    </div>
  </w-scale>
</template>

<script>
import WScale from '@/components/global/w-scale'
export default {
  props: {
    state: {
      type: Boolean,
      default: false
    },
    scaleTemp: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
    }
  },
  mounted () { },
  components: {
    WScale
  },
  watch: {},
  computed: {},
  methods: {
    handleClose () {
      this.$emit('handleClose')
    },
    cvByTemp () {
      this.$emit('cvByTemp', this.scaleTemp)
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/assets/scss/global/variable';
.scale-dialog {
  position: relative;
  .close-icon {
    position: absolute;
    top: -45px;
    right: 0;
  }
  .scale-temp-img {
    width: 350px;
  }
  .use {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100px;
    height: 32px;
    border-radius: 2px;
    background-color: $color-theme;
    color: $color-light;
  }
}
</style>